import type { TOC } from '@ember/component/template-only'
import Component from '@glimmer/component'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface HomeschoolTileArgs {
  title: string
  imgSrc: string
  imgAlt: string
  tileDescription: string
  themeKey: ThemeKeys.blue | ThemeKeys.green | ThemeKeys.orange
}

interface BaseTileSignature {
  Element: Element
  Blocks: {
    default: []
  }
}

export const Tile: TOC<BaseTileSignature> = <template>
  <content-tile
    class="flex h-[360px] flex-col overflow-hidden rounded-2xl shadow-[0_0_12px_rgba(209,208,208,1)] print:rounded-none print:border print:border-black print:shadow-none"
    ...attributes
  >
    {{yield}}
  </content-tile>
</template>

interface HomeschoolTileSignature {
  Args: HomeschoolTileArgs
  Element: Element
  Blocks: {
    default: []
  }
}

const themes: Record<ThemeKeys.blue | ThemeKeys.green | ThemeKeys.orange, string> = {
  [ThemeKeys.blue]: 'bg-oceany-blue-300 text-white',
  [ThemeKeys.green]: 'bg-ms-green-300 text-white',
  [ThemeKeys.orange]: 'bg-juicy-orange-200 text-dusty-black-300',
}

export class HomeschoolBaseTile extends Component<HomeschoolTileSignature> {
  get theme() {
    return themes[this.args.themeKey]
  }

  <template>
    <Tile data-test-homeschool-content-tile ...attributes>
      <div class="{{this.theme}} flex items-center justify-start px-3 py-4">
        <h4>{{@title}}</h4>
      </div>

      <div class="flex h-full flex-col justify-start bg-white px-8 py-6">
        <div>
          <div class="mb-8 flex items-start">
            <img class="mr-6" src={{@imgSrc}} alt={{@imgAlt}} />
            <p class="leading-snug">{{@tileDescription}}</p>
          </div>
        </div>
        <div>
          {{yield}}
        </div>
      </div>
    </Tile>
  </template>
}

export default HomeschoolBaseTile
